import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class CustomerService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/customers', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/customer/{id}', { id: id }), params);
	}
}

